export default __webpack_public_path__ + "static/media/stopWatch.feb3369a.svg";